import { Icon, Menu, useSnackbar } from "@mindlercare/ui-web";
import { handleQuestionnaireError } from "api/questionnaireHelpers";
import { usePostQuestionnaireRequestsMutation } from "api/useQuestionnaireQueries";
import { QuestionnaireTableRow } from "core/types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ConfirmQuestionnaireDeleteModal } from "../questionnaireModal/confirmQuestionnaireDeleteModal";

export const ThreeDotsAction = ({
  row,
  patientUserId,
  patientName,
}: {
  row: QuestionnaireTableRow;
  patientUserId?: string;
  patientName?: string;
}) => {
  const { t } = useTranslation();
  const { mutateAsync: postQuestionnaireRequests } =
    usePostQuestionnaireRequestsMutation();
  const { enqueueSnackbar } = useSnackbar();
  const [confirmOpen, setConfirmOpen] = useState<boolean>(false);

  if (row.dateCompleted !== "--") return null;

  return (
    <>
      <Menu>
        <Menu.Trigger variant="icon" testId="removeIcbtEllipsis">
          <Icon.MoreVert />
        </Menu.Trigger>
        <Menu.Items>
          <Menu.Item
            onClick={async () => {
              if (row?.clinicalId && patientUserId) {
                try {
                  await postQuestionnaireRequests([
                    {
                      userId: patientUserId,
                      clinicalId: row.clinicalId,
                    },
                  ]);
                  enqueueSnackbar({
                    text: `${t("REMINDED_X_OF_Y", {
                      subject: patientName,
                      target: row?.clinicalId,
                    })}`,
                    isError: false,
                  });
                } catch (error) {
                  handleQuestionnaireError(
                    error,
                    "NOT_PATIENT_POST_QUESTIONNAIRES_ERROR",
                    enqueueSnackbar,
                    t,
                  );
                }
              }
            }}
          >
            {t("REMIND")}
          </Menu.Item>
          <Menu.Item
            onClick={() => {
              setConfirmOpen(true);
            }}
          >
            {t("DELETE")}
          </Menu.Item>
        </Menu.Items>
      </Menu>

      <ConfirmQuestionnaireDeleteModal
        requestId={row?.id}
        clinicalId={row?.clinicalId}
        open={confirmOpen}
        setModalIsOpen={setConfirmOpen}
        patientUserId={patientUserId}
      />
    </>
  );
};
